export default {
	getHashes: {
		apiServiceMethodName: 'getCacheHashes',
	},
}
